module.exports = __webpack_public_path__ + "img/39.889b1c1a.jpg";